// extracted by mini-css-extract-plugin
module.exports = {"TabsList__wrapper":"TabsList_TabsList__wrapper__23V15","TabsList":"TabsList_TabsList__2cBPf","TabsList__wrapper_twoItems":"TabsList_TabsList__wrapper_twoItems__1Yv3z"};